var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"itemTitle bg-none"},[_c('i',{staticClass:"iconinname iconfont",class:_vm.titleData.icon,staticStyle:{"margin":"0"},on:{"click":function($event){return _vm.handel(_vm.titleData.triggerEvent)}}}),_c('span',{staticClass:"titleName"},[_vm._v(_vm._s(_vm.titleData.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }